// common graphing functions
import { updateDataArea, populateCountryFilters, updateFilters, updatePrimarySelector, filterByCountry, generateATAbstract, generateStatSummary, arrayUnique } from './graphing-functions';

import { fetchJSON } from './search-functions';

// Get publication data
let publicationData = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/articles');
let stats = fetchJSON('https://opensheet.elk.sh/1UASpyY5jUr3ba_l0uBlC-h8D3dACMXj0Nk66IBId8hw/global_stats');
let atTechTypes: any
let statTechTypes: any


publicationData.then(data => {
  atTechTypes = [... new Set(data.map(at => at['AP Type']))]
  publicationData = data;
  checkCanRun();
})

stats.then(data => {
  statTechTypes = [... new Set(data.map(at => at['ap-type']))]
  stats = data;
  checkCanRun();
})

function checkCanRun() {
  if (atTechTypes && statTechTypes) {
    runPage();
  }
}

/*  --------------------- Runtime ---------------------- */

function runPage() {
  const typesOfAT = arrayUnique(atTechTypes.concat(statTechTypes)).sort();
  // Data Parsing
  const dataByAT = typesOfAT.map(publication => {
    return { name: publication, data: publicationData.filter(datum => datum['AP Type'] === publication) }
  })

  const statsByAT = typesOfAT.map(statistic => {
    return { name: statistic, data: stats.filter(datum => datum['ap-type'] === statistic) }
  })

  // Constants for dropdown and display area
  const dataArea: HTMLDivElement = document.getElementById('js-data-container');
  const select: HTMLSelectElement = document.getElementById('js-at-select');
  const filter: HTMLSelectElement = document.getElementById('js-country-select');
  const clearFilters: HTMLButtonElement = document.getElementById('js-clear-filters');
  const abstract: HTMLSpanElement = document.getElementById('js-abstract');
  const statsArea: HTMLSpanElement = document.getElementById('js-stat-container');


  // Global access to the in-use data set.
  var activeData: any
  var activeStats: any

  // Populate Dropdown
  for (var i = 0; i < atTechTypes.length; i++) {
    var option = document.createElement("option");
    var currentAT = atTechTypes[i];
    option.text = currentAT.slice(0, -7);
    option.value = currentAT;
    select?.add(option);
  }

  // When the user changes the country
  select?.addEventListener('change', () => {
    let at = select?.value;
    let country = filter?.value;
    activeData = updatePrimarySelector(at, dataByAT);
    activeStats = updatePrimarySelector(at, statsByAT);

    if (country) {
      let currentAvailableCountries = [... new Set(activeData.map(country => country.Country))];
      console.log(currentAvailableCountries);

      if (currentAvailableCountries.includes(country)) {
        // Do same action as the filter
        let filteredData = filterByCountry(country, activeData);

        if (filteredData && dataArea) {
          updateDataArea(dataArea, filteredData);
          generateATAbstract(filteredData, abstract, at, country);
          updateFilters(activeData, filter, "country");
          filter.value = country;
          statsArea.classList.remove('active');
        }

        // Initialise the clear filters button
        if (!clearFilters.classList.contains('active')) {
          clearFilters.classList.add('active')
        }
      } else {
        // If the AT is not on the selected country, then show an error modal.
        document.getElementById("aterrormodal")?.showModal();
        clearFilters.classList.remove('active')
        statsArea.classList.add('active');
        updateFilters(activeData, filter, "country");
        updateDataArea(dataArea, activeData);
        generateATAbstract(activeData, abstract, at);
        generateStatSummary(activeStats, statsArea, at);
      }
    } else {
      updateFilters(activeData, filter, "country");
      updateDataArea(dataArea, activeData);
      generateATAbstract(activeData, abstract, at);
      generateStatSummary(activeStats, statsArea, at);
    }
  });

  // When the user filters the list 
  filter?.addEventListener('change', () => {
    let at = select?.value;
    let country = filter?.value;
    let filteredData = filterByCountry(country, activeData);
    generateATAbstract(filteredData, abstract, at, country);
    statsArea.classList.remove('active');

    if (filteredData && dataArea) {
      updateDataArea(dataArea, filteredData);
    }

    // Initialise the clear filters button
    if (!clearFilters.classList.contains('active')) {
      clearFilters.classList.add('active')
    }
  });

  // when a user clears the list 
  clearFilters?.addEventListener('click', () => {
    filter.selectedIndex = 0;
    let at = select?.value;
    activeData = updatePrimarySelector(at, dataByAT);
    generateATAbstract(activeData, abstract, at);
    generateStatSummary(activeStats, statsArea, at);
    statsArea.classList.add('active');


    if (activeData && dataArea) {
      updateDataArea(dataArea, activeData);
      clearFilters.classList.remove('active')
    } else {
      clearFilters.innerText = "Something's gone wrong, please reload"
    }

  })

  //Initial population
  if (dataArea) {
    let initialAT = select?.value;
    let initialData = updatePrimarySelector(initialAT, dataByAT);
    let initialStats = updatePrimarySelector(initialAT, statsByAT);
    populateCountryFilters(initialData, filter);
    updateDataArea(dataArea, initialData);
    generateATAbstract(initialData, abstract, initialAT);
    generateStatSummary(initialStats, statsArea, initialAT);
    activeData = initialData;
    activeStats = initialStats;
  }
}



